export default "__VITE_ASSET__HkC4PNau__"